import { cn } from '@crossnokaye/ux-common';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { NavLink } from '@/components/navigation/nav-link';
import { useForcePointTotals } from '@/hooks/query-hooks/settings';
import { useCurrentFacility } from '@/hooks/use-current-facility';

export const ForcedIOBadge = ({ label, className }: { label: string; className?: string }) => {
  const { organizationId: orgId, agentId } = useCurrentFacility();
  const { data: forcedPointTotals } = useForcePointTotals({ orgId, agentId });

  const total = forcedPointTotals?.agentTotal ?? 0;

  return (
    total > 0 && (
      <NavLink routeId={AtlasRouteIds.IOStatus}>
        <div
          className={cn(
            'flex bg-warning rounded-full px-3 text-black font-bold items-center cursor-pointer',
            className
          )}
        >
          {label} {total}
        </div>
      </NavLink>
    )
  );
};
